import {
  CreditCardOutlined,
  FileDoneOutlined,
  FileProtectOutlined,
  FileTextOutlined,
  FlagOutlined,
  MailOutlined,
  RobotOutlined,
  SafetyCertificateOutlined,
  UnorderedListOutlined,
  WarningOutlined
} from "@ant-design/icons"
import type { ReactNode } from "react"

import Icon from "../../../Icon"

// Keep in sync with the mobile app's NotificationGroupIcon map.
const NOTIFICATION_GROUP_ICONS: Record<string, ReactNode> = {
  LEADS: <Icon type="Leads" />,
  PROPOSALS: <FileTextOutlined />,
  CONTRACTS: <FileDoneOutlined />,
  PROJECTS: <Icon type="Projects" />,
  MILESTONES: <FlagOutlined />,
  PAYMENTS: <CreditCardOutlined />,
  INVOICES: <Icon type="Dollar" />,
  FINANCIAL_ALERTS: <WarningOutlined />,
  COMMUNICATION: <MailOutlined />,
  TASKS: <UnorderedListOutlined />,
  ALBUM_FILES: <Icon type="Files" />,
  SYSTEM: <Icon type="Users" />,
  USER_PROFILE: <Icon type="User" />,
  CALENDAR: <Icon type="Calendar" />,
  PERMISSIONS: <SafetyCertificateOutlined />,
  ASSISTANT: <RobotOutlined />,
  SUBCONTRACTORS: <Icon type="Subcontractors" />,
  CUSTOMER_ACTIVITY: <Icon type="Customers" />,
  SIGNATURES: <FileProtectOutlined />
}

const FALLBACK_GROUP_ICON = <Icon type="Bell" />

export function NotificationGroupIcon({ groupKey }: { groupKey: string }) {
  return (
    <span
      aria-hidden="true"
      data-testid="notification-group-icon"
      className="inline-flex text-base text-primary"
    >
      {NOTIFICATION_GROUP_ICONS[groupKey] ?? FALLBACK_GROUP_ICON}
    </span>
  )
}
